var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-warp"},[_c('span',{staticClass:"progress-name"},[_vm._v(_vm._s(_vm.progress.name))]),_c('div',{staticClass:"progress-line",style:({width: _vm.progress.per})},[_c('span',{staticClass:"num-unit"},[_vm._v(_vm._s(_vm.progress.num)+"家")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }